import React from 'react'

import { useLookupRecords } from 'features/views/ListView/hooks/useLookupRecords'

import { Box } from 'ui/components/Box'
import { Select, SelectOption } from 'ui/components/Select'
import { Body } from 'ui/components/Text'

type RelationshipFieldDefaultValueProps = {
    value: FieldDto['default_value']
    onChange: (value: FieldDto['default_value']) => void
    field: FieldDto
}
export const RelationshipFieldDefaultValue: React.FC<RelationshipFieldDefaultValueProps> = ({
    field,
    value,
    onChange,
}) => {
    const { records, isLoading: isLoadingRecords } = useLookupRecords({
        field,
        alwaysShowValueRecords: true,
    })

    return (
        <Select
            placeholder="Select a default value"
            value={value?.value}
            onChange={(value: any) => onChange({ type: 'constant', value })}
            isClearable
            multiSelect={field.type == 'multi_lookup'}
            isLoading={isLoadingRecords}
            modal={false}
        >
            {records?.map((record) => (
                <SelectOption
                    key={record._sid}
                    value={record._sid}
                    label={String(record._primary ?? '')}
                />
            ))}

            {!isLoadingRecords && records?.length === 0 && (
                <Box flex justifyContent="center">
                    <Body size="xs">No options available</Body>
                </Box>
            )}
        </Select>
    )
}
